import { render, staticRenderFns } from "./ThemeConfig.vue?vue&type=template&id=f961b7ae"
import script from "./ThemeConfig.vue?vue&type=script&lang=js"
export * from "./ThemeConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports